import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  href?: string;
  text?: string;
  limitText?: string;
  hideLimitText?: boolean;
  className?: string;
}
export function CTAButton({
  href = '#oferte',
  text = 'Click aici pentru Terapie',
  limitText = '*locuri limitate',
  hideLimitText = false,
  className = ''
}: CTAButtonProps) {
  const isAnchor = href.startsWith('#');
  return <div className={`flex flex-col items-center gap-2 ${className}`} data-id="element-1658">
      <a href={href} {...isAnchor ? {} : {
      target: '_top'
    }} className="group inline-flex items-center justify-center gap-3 bg-brand-gold text-brand-cream font-heading font-semibold text-lg px-8 py-4 rounded-full hover:bg-brand-purple transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1 w-full sm:w-auto text-center" data-id="element-1659">
        {text}
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1660" />
      </a>
      {!hideLimitText && <span className="text-sm font-subtitle italic text-brand-textSec" data-id="element-1661">
          {limitText}
        </span>}
    </div>;
}